var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFundadores(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#831131"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.5,70.9c-1.2,0-2.4-0.1-3.7-0.4c-4.7-1-4.1-6.8-3.6-11.5c0.2-1.5,0.3-2.9,0.3-4c0-27.5,22.4-49.8,49.8-49.8    s49.8,22.4,49.8,49.8v0.9l-0.8,0.4c-0.4,0.2-39,19.8-68.6-12.2l2.2-2c11.8,12.7,26.2,18.6,43.1,17.4c10.5-0.8,18.6-4.2,21.2-5.3    c-0.5-25.4-21.3-45.9-46.8-45.9c-25.8,0-46.8,21-46.8,46.8c0,1.3-0.2,2.8-0.3,4.3c-0.5,4.4-0.7,7.8,1.2,8.2    C59.4,70,65.6,57.5,65.7,57.3l2.7,1.3C68.3,58.8,62.4,70.9,50.5,70.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M94.5,115c-18.1,0-39.4-5.2-43.9-45.5l3-0.3c4.2,37.7,23,42.8,40.9,42.8c12,0,21.3-3.7,27.8-11.1    c13.4-15.3,10.1-41.2,10.1-41.5l3-0.4c0,0.3,0.9,7,0,15.7c-0.8,8.1-3.4,19.6-10.8,28.2C117.5,110.9,107.4,115,94.5,115z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.6,183.9l-3-0.1c0.5-19.6,5.7-34.1,15.3-43c9.8-9.1,21.8-10,28-9.8c0,0,0.1,0,0.1,0c4.8,0,8.7-13.6,9.9-23.4l3,0.4    c-0.3,2.7-3.7,26.4-13.2,26C54,133.8,43,134.6,34,143C24.9,151.4,20.1,165.2,19.6,183.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M172.4,188.7h-3c0-25.2-8.4-38.6-15.5-45.5c-5.9-5.6-12.9-8.8-19.4-8.5c-5.9,0.2-10.6-1.5-14-5.1    c-7.1-7.5-6.1-20.4-6.1-21l3,0.3c0,0.1-1,12.1,5.2,18.6c2.8,3,6.7,4.4,11.7,4.2c7.3-0.2,15.1,3.2,21.5,9.4    C163.4,148.3,172.4,162.4,172.4,188.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.4,142c-11,0-22-4-30.4-11.9l2.1-2.2c14.8,13.9,38.1,14.9,54,2.3l0.5-0.4l1.9,2.4l-0.5,0.4    C115.9,138.9,106.1,142,96.4,142z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundadores);
export default __webpack_public_path__ + "static/media/fundadores.f1fbe3395828a12c2189a1a5fca25159.svg";
export { ForwardRef as ReactComponent };